"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6792,8220],{

/***/ 96792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ScrollTop_ScrollTop; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/FloatingButton/ScrollTop/ScrollTop.styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  background: transparent;\n  bottom: 24px;\n  z-index: 99;\n  display: flex;\n  flex-direction: column-reverse;\n  gap: 2.5rem;\n  font-family: ",
        ";\n  ::after {\n    color: ",
        ";\n    background-color: ",
        ";\n  }\n  &.btn_scroll_cfe {\n    right: ",
        ";\n    left: ",
        ";\n  }\n  & > .scroll {\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    outline: none;\n    border: none;\n    width: 3rem;\n    height: 3rem;\n    font-size: 3rem;\n    padding: 0.75rem 1rem;\n    color: ",
        ";\n    background-color: ",
        ";\n    border-radius: ",
        ";\n    cursor: pointer;\n  }\n  @media screen and (min-width: 768px) {\n    &.btn_scroll_builder {\n      right: ",
        ";\n      left: ",
        ";\n      bottom: 80px;\n    }\n    &.btn_scroll_preview_desktop {\n      right: ",
        ";\n      left: ",
        ";\n      bottom: 48px;\n    }\n    &.btn_scroll_preview_mobile {\n      right: ",
        ";\n      left: ",
        ";\n      bottom: 48px;\n    }\n  }\n  @media screen and (min-width: 1441px) {\n    &.btn_scroll_builder {\n      right: ",
        ";\n      bottom: 80px;\n    }\n  }\n  @media screen and (max-width: 767px) {\n    &.btn_scroll_builder {\n      right: ",
        ";\n      left: ",
        ";\n      bottom: 80px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ScrollTopWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ScrollTopWrapper",
    componentId: "sc-1c0f5aca-0"
})(_templateObject(), function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeConfig) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonPrimary) === null || ref1 === void 0 ? void 0 : ref1.fontFamily;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeConfig) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonPrimary) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeConfig) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonPrimary) === null || ref1 === void 0 ? void 0 : ref1.backgroundHoverColor;
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.styleConfig) === "right" ? "24px" : "unset";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.styleConfig) === "left" ? "24px" : "unset";
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeConfig) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonPrimary) === null || ref1 === void 0 ? void 0 : ref1.color;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeConfig) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonPrimary) === null || ref1 === void 0 ? void 0 : ref1.backgroundColor;
}, function(props) {
    var ref, ref1;
    return props === null || props === void 0 ? void 0 : (ref = props.themeConfig) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonPrimary) === null || ref1 === void 0 ? void 0 : ref1.borderRadius;
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.styleConfig) === "right" ? "400px" : "unset";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.styleConfig) === "left" ? "4%" : "unset";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.styleConfig) === "right" ? "7%" : "unset";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.styleConfig) === "left" ? "4%" : "unset";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.styleConfig) === "right" ? "38.5%" : "unset";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.styleConfig) === "left" ? "4%" : "unset";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.styleConfig) === "right" ? "400px" : "unset";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.styleConfig) === "right" ? "400px" : "unset";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.styleConfig) === "left" ? "6.5%" : "unset";
});

// EXTERNAL MODULE: ./src/components/WidgetMaker/utils/common.ts
var common = __webpack_require__(37179);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/getStylesConfig.js
var getStylesConfig = __webpack_require__(42757);
// EXTERNAL MODULE: ./src/components/FloatingWhatsapp/index.js
var FloatingWhatsapp = __webpack_require__(18220);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/assets/svgExports/ScrollTopArrow.js

var ScrollTopArrow = function(props) {
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("svg", {
        width: "17",
        height: "25",
        viewBox: "0 0 17 25",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.25256 0.904158L7.25256 23.2374C7.25256 23.7413 7.65968 24.1484 8.1636 24.1484C8.66752 24.1484 9.07465 23.7413 9.07465 23.2374L9.07465 3.1049L14.6036 8.63381C14.9594 8.98968 15.5374 8.98968 15.8932 8.63381C16.2491 8.27793 16.2491 7.69998 15.8932 7.34411L8.80703 0.257885C8.5451 -0.00403943 8.15506 -0.0809094 7.81342 0.0614418C7.47462 0.203793 7.25256 0.536892 7.25256 0.904158Z",
                fill: props === null || props === void 0 ? void 0 : props.color
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.156447 7.99909C0.156447 8.23254 0.244706 8.466 0.424067 8.64252C0.779944 8.99839 1.35789 8.99839 1.71377 8.64252L8.80853 1.54775C9.16441 1.19187 9.16441 0.61393 8.80853 0.258053C8.45265 -0.0978241 7.87471 -0.097824 7.51883 0.258053L0.424067 7.35282C0.244706 7.53218 0.156447 7.76563 0.156447 7.99909Z",
                fill: props === null || props === void 0 ? void 0 : props.color
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts
var ssrStore = __webpack_require__(20155);
;// CONCATENATED MODULE: ./src/components/DesignSystem/ModernTheme/FloatingButton/ScrollTop/ScrollTop.js









var ScrollTop = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var ref11 = (0,react.useState)((0,common/* transformWidgetProps */.Ak)(props === null || props === void 0 ? void 0 : (ref = props.config) === null || ref === void 0 ? void 0 : (ref1 = ref.scrollToTop) === null || ref1 === void 0 ? void 0 : ref1.config)), floatingButtonState = ref11[0];
    var storeData = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    var widgetData = (0,es/* useSelector */.v9)(function(state) {
        return {
            widgetData: state.widgetsReducer
        };
    }).widgetData;
    var ref12 = (0,react.useState)(storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.theme) === null || ref2 === void 0 ? void 0 : ref2.style_template), propStyle = ref12[0], setPropStyle = ref12[1];
    (0,react.useEffect)(function() {
        if (widgetData === null || widgetData === void 0 ? void 0 : widgetData.activeStyleTemplate) {
            setPropStyle((0,getStylesConfig/* getStyleForProps */.dn)(widgetData === null || widgetData === void 0 ? void 0 : widgetData.activeStyleTemplate));
        } else {
            var ref;
            setPropStyle((0,getStylesConfig/* getStyleForProps */.dn)(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.style_template));
        }
    }, [
        widgetData === null || widgetData === void 0 ? void 0 : widgetData.activeStyleTemplate,
        storeData === null || storeData === void 0 ? void 0 : (ref3 = storeData.theme) === null || ref3 === void 0 ? void 0 : ref3.style_template
    ]);
    var onBtnClick = function() {
        var targetElement = document.getElementById("Header");
        if (targetElement) {
            targetElement.scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "start"
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScrollTopWrapper, {
        themeConfig: propStyle,
        styleConfig: floatingButtonState === null || floatingButtonState === void 0 ? void 0 : (ref4 = floatingButtonState.ScrollToTop) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.styleConfig) === null || ref5 === void 0 ? void 0 : ref5.alignment,
        className: "".concat((props === null || props === void 0 ? void 0 : props.inBuilder) && (props === null || props === void 0 ? void 0 : props.showPreview) ? "btn_scroll_builder" : "btn_scroll_preview_".concat(props === null || props === void 0 ? void 0 : props.device), " ").concat((props === null || props === void 0 ? void 0 : props.inBuilder) === false && (props === null || props === void 0 ? void 0 : props.showPreview) === undefined ? "btn_scroll_cfe" : ""),
        children: [
            (props === null || props === void 0 ? void 0 : (ref6 = props.config) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.scrollToTop) === null || ref7 === void 0 ? void 0 : ref7.isEnabled) && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "scroll",
                onClick: onBtnClick,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollTopArrow, {
                    color: propStyle === null || propStyle === void 0 ? void 0 : (ref8 = propStyle.buttonPrimary) === null || ref8 === void 0 ? void 0 : ref8.color
                })
            }),
            (props === null || props === void 0 ? void 0 : (ref9 = props.config) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.whatsappCTA) === null || ref10 === void 0 ? void 0 : ref10.isEnabled) && /*#__PURE__*/ (0,jsx_runtime.jsx)(FloatingWhatsapp.FloatingWhatsapp, {
                overRideDefaultStyle: true
            })
        ]
    });
};
/* harmony default export */ var ScrollTop_ScrollTop = (ScrollTop);


/***/ }),

/***/ 18220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FloatingWhatsapp": function() { return /* binding */ FloatingWhatsapp; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67936);
/* harmony import */ var _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86812);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13886);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25617);
/* harmony import */ var src_hooks_useStoreContactDetails__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99375);
/* harmony import */ var _utils_getWhatsAppRedirectionUrl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30066);
/* harmony import */ var src_hooks_useStoreSubscriptionConfigs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72988);








var FloatingWhatsapp = function(props) {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    var storePhone = (0,src_hooks_useStoreContactDetails__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().storePhone;
    var websiteStatus = (0,src_hooks_useStoreSubscriptionConfigs__WEBPACK_IMPORTED_MODULE_6__/* .useStoreSubscriptionConfigs */ .D)().websiteStatus;
    var ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return {
            storeData: state.storeReducer.store,
            userData: state.userReducer
        };
    }), _storeData = ref.storeData, store_info = _storeData.store_info, store_id = _storeData.store_id, userData = ref.userData;
    var iconClick = function() {
        if (storePhone) {
            var ref;
            dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_7__/* .pushEventsLog */ .U)({
                event_name: "Cx_WA_Clicked",
                data: {
                    store_id: store_id,
                    domain: store_info === null || store_info === void 0 ? void 0 : store_info.domain,
                    page: window.location.href,
                    device: _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_1__/* .deviceWidth */ .o <= _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .MAX_MOBILE_WIDTH */ .Cf ? "Mobile" : "Desktop",
                    cx_number: userData === null || userData === void 0 ? void 0 : (ref = userData.data) === null || ref === void 0 ? void 0 : ref.phone
                }
            }));
        }
        window.open((0,_utils_getWhatsAppRedirectionUrl__WEBPACK_IMPORTED_MODULE_5__/* .getWhatAppRedirectionUrlHelp */ .Nz)());
    };
    if (websiteStatus.isNewStoreWebsiteInactive) {
        return null;
    }
    return !!storePhone && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        style: !(props === null || props === void 0 ? void 0 : props.overRideDefaultStyle) ? {
            position: "fixed",
            bottom: 32,
            right: 32
        } : null,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            src: "/assets/images/whatsapp-round.svg",
            width: "48px",
            height: "48px",
            className: "pointer",
            alt: "Whatsapp",
            onClick: iconClick
        })
    });
};


/***/ }),

/***/ 72988:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ useStoreSubscriptionConfigs; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var src_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68037);
/* harmony import */ var src_utils_storeSubscriptionConfigs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14150);



function useStoreSubscriptionConfigs() {
    var storeData = (0,src_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSSRSelector */ .kF)(function(store) {
        return store.storeReducer.store;
    });
    var statuses = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return {
            subscriptionStatus: (0,src_utils_storeSubscriptionConfigs__WEBPACK_IMPORTED_MODULE_2__/* .getStoreSubscriptionConditions */ .Q)(storeData),
            websiteStatus: (0,src_utils_storeSubscriptionConfigs__WEBPACK_IMPORTED_MODULE_2__/* .getWebsiteLiveStatus */ .B)(storeData)
        };
    }, [
        storeData
    ]);
    return statuses;
}


/***/ })

}]);